import src from "IMAGE";
export default { src, width: 4246, height: 1500, blurWidth: 0, blurHeight: 0};
